/*
 * www.clearscore.com is shared with the Contentful SSR app. The edge picks which app serves a path,
 * but only on a document request. A client side transition keeps the visitor inside this bundle,
 * which still has its own stale copy of pages that have moved (legal pages, Learn), so every
 * navigation to another path has to be a full page load.
 */

type NavigateOptions = { replace?: boolean; state?: unknown };
export type Navigate = (to: string | number, options?: NavigateOptions) => void;
type DocumentLocation = Pick<Location, 'href' | 'pathname' | 'assign' | 'replace'>;

const withoutTrailingSlash = (pathname: string): string => pathname.replace(/(.)\/$/, '$1');

/**
 * Wraps Gatsby's `window.___navigate`, which gatsby `Link` and `navigate()` both call. Moves within
 * the current path (query or hash changes, history steps) stay client side.
 */
export const withDocumentNavigation =
    (clientNavigate: Navigate, location: DocumentLocation = window.location): Navigate =>
    (to, options = {}) => {
        if (typeof to === 'number') {
            clientNavigate(to, options);
            return;
        }

        const target = new URL(to, location.href);
        if (withoutTrailingSlash(target.pathname) === withoutTrailingSlash(location.pathname)) {
            clientNavigate(to, options);
        } else if (options.replace) {
            location.replace(target.href);
        } else {
            location.assign(target.href);
        }
    };
